import client from './client'
import install from './install'

// 子模块
// import room from './room'
// import professor from './professor'
// import chat from './chat'
// import video from './video'
// import course from './course'
import diagnosis from './diagnosis'

/**
 * 公共后端业务聚合层
 * http://gitlab.yintech.net/ytx/paprika/NewBee/backend/xlgg-biz-service/wikis/pages
 */
export default class BusinessApi {
  constructor (options) {
    if (BusinessApi.instance) {
      throw new Error('BusinessApi is singleton')
    }
    BusinessApi.instance = this

    this.options = options

    client.defaults.baseURL = options.baseURL

    // this.room = room
    // this.professor = professor
    // this.chat = chat
    // this.video = video
    // this.course = course
    this.diagnosis = diagnosis
  }
}

BusinessApi.instance = null
BusinessApi.install = install



// WEBPACK FOOTER //
// ./src/plugins/business-api/index.js